import { graphql, useStaticQuery } from 'gatsby';

// Better to have a list of common queries in one place than to have the same query repeated in multiple components.
// This also allows us to use the query in providers and pass the data down via context, which is better for performance than having multiple components all run the same query with useStaticQuery.
export const useCuratedListQuery = () => {
	const data = useStaticQuery(graphql`
{
	allSmartTagsCuratedList(
		filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
	) {
		edges {
			node {
				id
				title
				cards {
					title
					cta
					uri
					photo
					intro
				}
				background
				backgroundImage
				backgroundProps
				gridSize
				flush
				padding
				Audience {
					...AudienceRelationshipDetailsFragment
				}
			}
		}
	}
}
`);
	return { data };
};